import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import Snackbar from '@mui/material/Snackbar';
import { BASKET_LINK_BY_LANG_ID } from '@settings/localization/consts';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useDelivery from '../../../useDelivery';

interface BasketNotificationProps {
  open: boolean;
  onClose: () => void;
}

export const BasketNotification = ({ onClose, open }: BasketNotificationProps) => {
  const { t } = useTranslation('RoutesListComponent');

  const { useSettings } = useDelivery();
  const [settings] = useSettings().useState();

  const basketLink =
    BASKET_LINK_BY_LANG_ID[settings.primaryLanguageId] || BASKET_LINK_BY_LANG_ID.default;

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      ClickAwayListenerProps={{ onClickAway: () => null }}
    >
      <Alert severity="success">
        {t('RoutesListComponent:ProductNotification')}
        <Link href={basketLink} underline="hover">
          {t('RoutesListComponent:ProducttNotificationOrderLink')}
        </Link>
      </Alert>
    </Snackbar>
  );
};
